import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useScreenInit } from './useScreenInit.js';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ScrollToTop } from './components/ScrollToTop';
import { AnimatePresence, motion } from 'framer-motion';
import { FeaturedCollections } from './components/FeaturedCollections';
import { NewArrivals } from './components/NewArrivals';
import { ShopTheLook } from './components/ShopTheLook';
import { FeaturedProducts } from './components/FeaturedProducts';
import { GiftCardPromo } from './components/GiftCardPromo';
import { BrandStory } from './components/BrandStory';
import { SocialCommerce } from './components/SocialCommerce';
import { Newsletter } from './components/Newsletter';
import { Footer } from './components/Footer';
import { Shop } from './pages/Shop';
import { ProductDetail } from './pages/ProductDetail';
import { OurStory } from './pages/OurStory';
import { Colabs } from './pages/Colabs';
import { Contact } from './pages/Contact';
import { Checkout } from './pages/Checkout';
import { Policies } from './pages/Policies';
import { QuickViewModal } from './components/QuickViewModal';
import { CartDrawer } from './components/CartDrawer';
function AppContent() {
  useScreenInit();
  const location = useLocation();
  return <div className="min-h-screen bg-white font-sans text-black" data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Header data-id="element-2" />
      <QuickViewModal data-id="element-3" />
      <CartDrawer data-id="element-4" />
      <AnimatePresence mode="wait" data-id="element-5">
        <Routes location={location} key={location.pathname} data-id="element-6">
          <Route path="/" element={<motion.main initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-8">
                <Hero data-id="element-9" />
                <FeaturedCollections data-id="element-10" />
                <NewArrivals data-id="element-11" />
                <GiftCardPromo data-id="element-12" />
                <BrandStory data-id="element-13" />
                <Newsletter data-id="element-14" />
              </motion.main>} data-id="element-7" />
          <Route path="/shop" element={<motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.4
        }} data-id="element-16">
                <Shop data-id="element-17" />
              </motion.div>} data-id="element-15" />
          <Route path="/product/:id" element={<motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.4
        }} data-id="element-19">
                <ProductDetail data-id="element-20" />
              </motion.div>} data-id="element-18" />
          <Route path="/our-story" element={<motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.4
        }} data-id="element-22">
                <OurStory data-id="element-23" />
              </motion.div>} data-id="element-21" />
          <Route path="/colabs" element={<motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.4
        }} data-id="element-25">
                <Colabs data-id="element-26" />
              </motion.div>} data-id="element-24" />
          <Route path="/contact" element={<motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.4
        }} data-id="element-28">
                <Contact data-id="element-29" />
              </motion.div>} data-id="element-27" />
          <Route path="/checkout" element={<motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.4
        }} data-id="element-31">
                <Checkout data-id="element-32" />
              </motion.div>} data-id="element-30" />
          <Route path="/policies" element={<motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.4
        }} data-id="element-34">
                <Policies data-id="element-35" />
              </motion.div>} data-id="element-33" />
        </Routes>
      </AnimatePresence>
      <Footer data-id="element-36" />
    </div>;
}
export function App() {
  return <Router data-id="element-37">
      <AppContent data-id="element-38" />
    </Router>;
}